// grab the query key/values from the uri
const getQueryFromUri = (deepLinkUri) => {
  const queriesArray = deepLinkUri && deepLinkUri.split(/[?&]+/).splice(1);
  return (
    queriesArray &&
    queriesArray.reduce((result, current) => {
      const query = current.split('=');
      return {
        ...result,
        [query[0]]: query[1],
      };
    }, {})
  );
};

module.exports = getQueryFromUri;
